import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { BrowserRouter } from 'react-router-dom';


import { ApiProvider } from "@reduxjs/toolkit/query/react";
import { apiSlice } from './AppStore/ApiSlice';

import { Provider } from 'react-redux';
import { store } from "./AppStore/store"

import { AuthProvider } from './Context/AuthProvider';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);